// extracted by mini-css-extract-plugin
export default {"callbackContainer":"Callback_callbackContainer__0nQoy"};